import React from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useGetMembershipTypes } from "@/services/RegisterCompany";
import { useTranslation } from "react-i18next";

const SelectAddressType: React.FC<SelectProps> = (props) => {
  const { data: membershipOptions, isLoading } = useGetMembershipTypes();
  const { t } = useTranslation();

  const options = transformDataToSelectOption(membershipOptions || [], "value", "label", t);

  return <Select data={options} loading={isLoading} {...props} />;
};

export default SelectAddressType;
